import { format } from 'date-fns';

import { DATETIME_FORMAT } from './consts';

export const formatDateTime = (timestamp: string | number): string =>
  format(Number(timestamp), DATETIME_FORMAT);
